export default {
  forms: [],
  banks: [],
  income: [],
  assets: [],
  liabilities: [],
  donations: [],
  expenditures: [],
  single_form: null,
};
